import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

type FormFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string;
  helperText?: string;
};

export function FormField({ label, error, helperText, id, className, ...inputProps }: FormFieldProps) {
  const inputId = id ?? `field-${label.toLowerCase().replace(/\s+/g, "-")}`;
  return (
    <div className="space-y-2">
      <Label htmlFor={inputId}>{label}</Label>
      <Input
        id={inputId}
        aria-invalid={Boolean(error) || undefined}
        aria-describedby={error || helperText ? `${inputId}-msg` : undefined}
        className={cn(error && "border-destructive focus-visible:ring-destructive", className)}
        {...inputProps}
      />
      {(error || helperText) && (
        <p
          id={`${inputId}-msg`}
          className={cn("text-xs", error ? "text-destructive" : "text-muted-foreground")}
        >
          {error ?? helperText}
        </p>
      )}
    </div>
  );
}
